var idProp = 'DemodalId';
var id = 0;

var generate = function generate() {
  return "__demodal_" + id++;
};

export var getModalId = function getModalId(modal) {
  if (typeof modal === 'string') {
    return modal;
  }

  if (!modal[idProp]) {
    modal[idProp] = generate();
  }

  return modal[idProp];
};